import React from "react";
import styles from "../styles/Navbar.module.scss";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

export default function Navbar({
  account,
  setSnackMessage,
  setSnackType,
  handleClick,
  openOrdersCount,
}) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const Contact = async () => {
    try {
      await axios
        .post(
          process.env.REACT_APP_test_url + `/api/contact/phone`,
          {
            platformid: secureLocalStorage.getItem("user")?.Id,
          },
          {
            headers: {
              Authorization: "Bearer " + secureLocalStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          setSnackType("success");
          setSnackMessage(t("ManagerWill"));
          handleClick();
        })
        .catch((e) => console.log(e));
    } catch (e) {
      console.log(e);
    }
  };
  const autoLogin = async () => {
    await axios
      .get(
        process.env.REACT_APP_test_url +
          `/api/account/autologin/${account?.Id}`,
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        if (window.innerWidth < 600) {
          window.location.href = res.data.autologin_url;
        } else {
          const newWindow = window.open(
            res.data.autologin_url,
            "_blank",
            "noopener,noreferrer"
          );
          if (newWindow) newWindow.opener = null;
        }
      })
      .catch((err) => {});
  };

  return (
    <div className={styles.navbar}>
      <div className={styles.navigation}>
        <span className={styles.to_terminal} onClick={() => autoLogin()}>
          {t("Trading Terminal")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <ellipse
              cx="8.00001"
              cy="4.00001"
              rx="2.66667"
              ry="2.66667"
              stroke="white"
              stroke-width="1.5"
            />
            <path
              d="M13.3333 11.6667C13.3333 13.3235 13.3333 14.6667 7.99999 14.6667C2.66666 14.6667 2.66666 13.3235 2.66666 11.6667C2.66666 10.0098 5.05447 8.66666 7.99999 8.66666C10.9455 8.66666 13.3333 10.0098 13.3333 11.6667Z"
              stroke="white"
              stroke-width="1.5"
            />
          </svg>
        </span>
        <div className={styles.nav_links}>
          <span className={styles.menu}>{t("Menu")}</span>
          <Link
            to="/cabinet"
            className={`${styles.button} ${
              pathname === "/cabinet" ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.67939 5.21532C1.33325 5.84768 1.33325 6.61049 1.33325 8.13611V9.15013C1.33325 11.7507 1.33325 13.051 2.1143 13.8589C2.89535 14.6668 4.15243 14.6668 6.66658 14.6668H9.33325C11.8474 14.6668 13.1045 14.6668 13.8855 13.8589C14.6666 13.051 14.6666 11.7507 14.6666 9.15013V8.13611C14.6666 6.61049 14.6666 5.84768 14.3205 5.21532C13.9743 4.58297 13.342 4.1905 12.0772 3.40558L10.7439 2.57808C9.40699 1.74836 8.73854 1.3335 7.99992 1.3335C7.26129 1.3335 6.59284 1.74836 5.25594 2.57808L3.92261 3.40558C2.65788 4.19051 2.02552 4.58297 1.67939 5.21532ZM5.99992 11.5002C5.72378 11.5002 5.49992 11.724 5.49992 12.0002C5.49992 12.2763 5.72378 12.5002 5.99992 12.5002H9.99992C10.2761 12.5002 10.4999 12.2763 10.4999 12.0002C10.4999 11.724 10.2761 11.5002 9.99992 11.5002H5.99992Z"
                fill="#FCFCFC"
              />
            </svg>
            {t("Home")}
          </Link>
          <Link
            to="/cabinet/accounts"
            className={`${styles.button} ${
              pathname.includes("/accounts") ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <ellipse
                cx="7.99992"
                cy="3.99967"
                rx="2.66667"
                ry="2.66667"
                fill="#51525C"
              />
              <ellipse
                cx="7.99992"
                cy="11.3337"
                rx="4.66667"
                ry="2.66667"
                fill="#51525C"
              />
            </svg>
            {t("Accounts")}
          </Link>
          <Link
            to="/cabinet/orders"
            className={`${styles.button} ${
              pathname.includes("/orders") ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M6.33333 1.3335C5.78105 1.3335 5.33333 1.78121 5.33333 2.3335V3.00016C5.33333 3.55245 5.78105 4.00016 6.33333 4.00016H9.66667C10.219 4.00016 10.6667 3.55245 10.6667 3.00016V2.3335C10.6667 1.78121 10.219 1.3335 9.66667 1.3335H6.33333Z"
                fill="#51525C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.33333 2.69124C3.49473 2.73829 2.96532 2.87192 2.58579 3.25146C2 3.83724 2 4.78005 2 6.66567V10.6657C2 12.5513 2 13.4941 2.58579 14.0799C3.17157 14.6657 4.11438 14.6657 6 14.6657H10C11.8856 14.6657 12.8284 14.6657 13.4142 14.0799C14 13.4941 14 12.5513 14 10.6657V6.66567C14 4.78005 14 3.83724 13.4142 3.25146C13.0347 2.87192 12.5053 2.73829 11.6667 2.69124V3.00016C11.6667 4.10473 10.7712 5.00016 9.66667 5.00016H6.33333C5.22876 5.00016 4.33333 4.10473 4.33333 3.00016V2.69124ZM4.66667 9.16683C4.39052 9.16683 4.16667 9.39069 4.16667 9.66683C4.16667 9.94297 4.39052 10.1668 4.66667 10.1668H10C10.2761 10.1668 10.5 9.94297 10.5 9.66683C10.5 9.39069 10.2761 9.16683 10 9.16683H4.66667ZM4.66667 11.5002C4.39052 11.5002 4.16667 11.724 4.16667 12.0002C4.16667 12.2763 4.39052 12.5002 4.66667 12.5002H8.33333C8.60948 12.5002 8.83333 12.2763 8.83333 12.0002C8.83333 11.724 8.60948 11.5002 8.33333 11.5002H4.66667Z"
                fill="#51525C"
              />
            </svg>
            <span style={{ position: 'relative', display: 'inline-block' }}>
              {t("Orders")}
              {openOrdersCount > 0 && (
                <span style={{ 
                  position: 'absolute',
                  top: '-10px',
                  right: '-30px',
                  background: "#F63D68",
                  fontSize: "12px",
                  color: "#fff",
                  padding: "2px",
                  borderRadius: "999px",
                  minWidth: "20px",
                  textAlign: "center",
                  fontWeight: 600,
                  lineHeight: "18px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                }}>{openOrdersCount}</span>
              )}
            </span>
          </Link>
          <Link
            to="/cabinet/transactions"
            className={`${styles.button} ${
              pathname.includes("/transactions") ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M6.66659 2.6665H9.33325C11.8474 2.6665 13.1045 2.6665 13.8855 3.44755C14.4479 4.00991 14.6054 4.81905 14.6494 6.1665H1.3504C1.39448 4.81905 1.55194 4.00991 2.1143 3.44755C2.89535 2.6665 4.15243 2.6665 6.66659 2.6665Z"
                fill="#51525C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.6663 8.54485L14.3939 8.27251C13.8081 7.68672 12.8584 7.68672 12.2726 8.27251L11.7383 8.8068C11.5251 8.23802 10.9765 7.83317 10.3333 7.83317C9.50483 7.83317 8.83325 8.50474 8.83325 9.33317V10.5091C8.50665 10.5454 8.18969 10.6887 7.93926 10.9392C7.35347 11.525 7.35347 12.4747 7.93926 13.0605L8.21193 13.3332H6.66659C4.15243 13.3332 2.89535 13.3332 2.1143 12.5521C1.33325 11.7711 1.33325 10.514 1.33325 7.99984C1.33325 7.70522 1.33325 7.42786 1.33451 7.1665H14.6653C14.6666 7.42786 14.6666 7.70522 14.6666 7.99984C14.6666 8.18848 14.6666 8.37004 14.6663 8.54485ZM3.99992 10.1665C3.72378 10.1665 3.49992 10.3904 3.49992 10.6665C3.49992 10.9426 3.72378 11.1665 3.99992 11.1665H6.66659C6.94273 11.1665 7.16659 10.9426 7.16659 10.6665C7.16659 10.3904 6.94273 10.1665 6.66659 10.1665H3.99992Z"
                fill="#51525C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3333 8.83317C10.6094 8.83317 10.8333 9.05703 10.8333 9.33317V12.1261L11.313 11.6463C11.5083 11.451 11.8249 11.451 12.0201 11.6463C12.2154 11.8415 12.2154 12.1581 12.0201 12.3534L10.6868 13.6867C10.4915 13.882 10.175 13.882 9.9797 13.6867L8.64637 12.3534C8.4511 12.1581 8.4511 11.8415 8.64637 11.6463C8.84163 11.451 9.15821 11.451 9.35347 11.6463L9.83325 12.1261V9.33317C9.83325 9.05703 10.0571 8.83317 10.3333 8.83317ZM12.9797 8.97962C13.175 8.78435 13.4915 8.78435 13.6868 8.97962L15.0201 10.3129C15.2154 10.5082 15.2154 10.8248 15.0201 11.0201C14.8249 11.2153 14.5083 11.2153 14.313 11.0201L13.8333 10.5403V13.3332C13.8333 13.6093 13.6094 13.8332 13.3333 13.8332C13.0571 13.8332 12.8333 13.6093 12.8333 13.3332V10.5403L12.3535 11.0201C12.1582 11.2153 11.8416 11.2153 11.6464 11.0201C11.4511 10.8248 11.4511 10.5082 11.6464 10.3129L12.9797 8.97962Z"
                fill="#51525C"
              />
            </svg>
            {t("Transactions")}
          </Link>
          <Link
            to="/cabinet/applications"
            className={`${styles.button} ${
              pathname === "/cabinet/applications" ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.3131 13.687C12.5084 13.8822 12.8249 13.8822 13.0202 13.687L14.3535 12.3536C14.5488 12.1584 14.5488 11.8418 14.3535 11.6465C14.1583 11.4513 13.8417 11.4513 13.6464 11.6465L13.1666 12.1263V9.33341C13.1666 9.05727 12.9428 8.83341 12.6666 8.83341C12.3905 8.83341 12.1666 9.05727 12.1666 9.33341V12.1263L11.6869 11.6465C11.4916 11.4513 11.175 11.4513 10.9798 11.6465C10.7845 11.8418 10.7845 12.1584 10.9798 12.3536L12.3131 13.687Z"
                fill="white"
              />
              <path
                d="M6.66665 2.66675H9.33331C11.8475 2.66675 13.1045 2.66675 13.8856 3.4478C14.448 4.01016 14.6054 4.8193 14.6495 6.16675H1.35046C1.39454 4.8193 1.552 4.01016 2.11436 3.4478C2.89541 2.66675 4.15249 2.66675 6.66665 2.66675Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.66665 13.3334H9.33331C9.77298 13.3334 10.1742 13.3334 10.5411 13.3292L10.2727 13.0607C9.68687 12.475 9.68687 11.5252 10.2727 10.9394C10.5231 10.689 10.84 10.5456 11.1666 10.5093V9.33341C11.1666 8.50499 11.8382 7.83341 12.6666 7.83341C13.4951 7.83341 14.1666 8.50499 14.1666 9.33341V10.5093C14.3159 10.5259 14.4631 10.5648 14.6029 10.6261C14.6666 9.94485 14.6666 9.09075 14.6666 8.00008C14.6666 7.70546 14.6666 7.4281 14.6654 7.16675H1.33457C1.33331 7.4281 1.33331 7.70546 1.33331 8.00008C1.33331 10.5142 1.33331 11.7713 2.11436 12.5524C2.89541 13.3334 4.15249 13.3334 6.66665 13.3334ZM3.99998 10.1667C3.72384 10.1667 3.49998 10.3906 3.49998 10.6667C3.49998 10.9429 3.72384 11.1667 3.99998 11.1667H6.66665C6.94279 11.1667 7.16665 10.9429 7.16665 10.6667C7.16665 10.3906 6.94279 10.1667 6.66665 10.1667H3.99998ZM8.33331 10.1667C8.05717 10.1667 7.83331 10.3906 7.83331 10.6667C7.83331 10.9429 8.05717 11.1667 8.33331 11.1667H9.33331C9.60946 11.1667 9.83331 10.9429 9.83331 10.6667C9.83331 10.3906 9.60946 10.1667 9.33331 10.1667H8.33331Z"
                fill="white"
              />
            </svg>
            {t("Applications")}
          </Link>
          {/* <Link to='/swap' className={`${styles.button} ${pathname === '/swap' ? styles.active : ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width={"1.6vh"} height={"1.6vh"} viewBox="0 0 16 16" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016ZM3.64029 7.38905C3.88879 5.20008 5.74928 3.50016 8.0063 3.50016C9.4319 3.50016 10.6992 4.17878 11.5013 5.22847C11.669 5.44789 11.627 5.76168 11.4076 5.92934C11.1882 6.097 10.8744 6.05505 10.7067 5.83563C10.0858 5.02313 9.10743 4.50016 8.0063 4.50016C6.30134 4.50016 4.89085 5.75495 4.64879 7.38905H4.89093C5.09323 7.38905 5.27559 7.51095 5.35294 7.69787C5.43029 7.88479 5.38739 8.0999 5.24425 8.24285L4.4654 9.02062C4.2702 9.21556 3.95399 9.21556 3.75878 9.02062L2.97994 8.24285C2.8368 8.0999 2.7939 7.88479 2.87125 7.69787C2.9486 7.51095 3.13096 7.38905 3.33325 7.38905H3.64029ZM12.2411 6.9797C12.0459 6.78476 11.7297 6.78476 11.5344 6.9797L10.7556 7.75748C10.6125 7.90042 10.5696 8.11554 10.6469 8.30246C10.7243 8.48938 10.9066 8.61127 11.1089 8.61127H11.3511C11.109 10.2454 9.69851 11.5002 7.99356 11.5002C6.89755 11.5002 5.92315 10.9821 5.30185 10.176C5.13327 9.95734 4.8193 9.9167 4.60059 10.0853C4.38189 10.2539 4.34125 10.5678 4.50983 10.7865C5.31249 11.8279 6.57462 12.5002 7.99356 12.5002C10.2506 12.5002 12.1111 10.8002 12.3596 8.61127H12.6666C12.8689 8.61127 13.0513 8.48938 13.1286 8.30246C13.206 8.11554 13.1631 7.90042 13.0199 7.75748L12.2411 6.9797Z" fill="#51525C" />
            </svg>
            {t('Swap')}
          </Link> */}
          <Link
            to="/cabinet/verification"
            className={`${styles.button} ${
              pathname.includes("/verification") ? styles.active : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.39485 2.13368C6.2325 2.27203 6.15132 2.34121 6.06463 2.39932C5.86589 2.53252 5.6427 2.62497 5.40799 2.67131C5.30559 2.69153 5.19927 2.70001 4.98664 2.71698C4.45238 2.75961 4.18525 2.78093 3.96239 2.85965C3.44692 3.04172 3.04147 3.44717 2.8594 3.96263C2.78069 4.1855 2.75937 4.45263 2.71674 4.98688C2.69977 5.19952 2.69128 5.30584 2.67107 5.40823C2.62473 5.64294 2.53228 5.86613 2.39908 6.06487C2.34097 6.15157 2.27179 6.23274 2.13343 6.3951C1.78581 6.80302 1.61199 7.00698 1.51006 7.22023C1.27432 7.71346 1.27432 8.28686 1.51006 8.78009C1.61199 8.99334 1.7858 9.1973 2.13343 9.60523C2.27178 9.76756 2.34097 9.84876 2.39908 9.93546C2.53228 10.1342 2.62473 10.3574 2.67107 10.5921C2.69128 10.6945 2.69977 10.8008 2.71674 11.0134C2.75937 11.5477 2.78069 11.8148 2.8594 12.0377C3.04147 12.5532 3.44692 12.9586 3.96239 13.1407C4.18525 13.2194 4.45238 13.2407 4.98664 13.2833C5.19927 13.3003 5.30559 13.3088 5.40799 13.329C5.6427 13.3754 5.86589 13.4678 6.06463 13.601C6.15132 13.6591 6.2325 13.7283 6.39485 13.8666C6.80278 14.2143 7.00674 14.3881 7.21999 14.49C7.71322 14.7258 8.28662 14.7258 8.77985 14.49C8.9931 14.3881 9.19706 14.2143 9.60498 13.8666C9.76734 13.7283 9.84851 13.6591 9.93521 13.601C10.1339 13.4678 10.3571 13.3754 10.5919 13.329C10.6942 13.3088 10.8006 13.3003 11.0132 13.2833C11.5475 13.2407 11.8146 13.2194 12.0374 13.1407C12.5529 12.9586 12.9584 12.5532 13.1404 12.0377C13.2192 11.8148 13.2405 11.5477 13.2831 11.0134C13.3001 10.8008 13.3086 10.6945 13.3288 10.5921C13.3751 10.3574 13.4676 10.1342 13.6008 9.93546C13.6589 9.84876 13.728 9.76758 13.8664 9.60523C14.214 9.1973 14.3878 8.99334 14.4898 8.78009C14.7255 8.28686 14.7255 7.71346 14.4898 7.22023C14.3878 7.00698 14.214 6.80302 13.8664 6.3951C13.728 6.23274 13.6589 6.15157 13.6008 6.06487C13.4676 5.86613 13.3751 5.64294 13.3288 5.40823C13.3086 5.30584 13.3001 5.19952 13.2831 4.98688C13.2405 4.45263 13.2192 4.1855 13.1404 3.96263C12.9584 3.44717 12.5529 3.04172 12.0374 2.85965C11.8146 2.78093 11.5475 2.75961 11.0132 2.71698C10.8006 2.70001 10.6942 2.69153 10.5919 2.67131C10.3571 2.62497 10.1339 2.53252 9.93521 2.39932C9.84851 2.34121 9.76734 2.27203 9.60498 2.13368C9.19706 1.78605 8.9931 1.61223 8.77985 1.51031C8.28662 1.27456 7.71322 1.27456 7.21999 1.51031C7.00674 1.61223 6.80277 1.78605 6.39485 2.13368ZM10.9156 6.57559C11.1275 6.3637 11.1275 6.02016 10.9156 5.80827C10.7037 5.59638 10.3602 5.59638 10.1483 5.80827L6.91476 9.04177L5.85156 7.97857C5.63967 7.76668 5.29613 7.76668 5.08424 7.97857C4.87236 8.19045 4.87236 8.53399 5.08424 8.74588L6.53111 10.1927C6.74299 10.4046 7.08653 10.4046 7.29842 10.1927L10.9156 6.57559Z"
                fill="#51525C"
              />
            </svg>
            {t("Verification")}
          </Link>
          {/* <Link
            to="/cabinet/chat"
            className={`${styles.button} ${
              pathname.includes("/chat") ? styles.active : ""
            }`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width='1.6vh' viewBox="0 0 512 512"><path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"/></svg>
            {t("Chat")}
          </Link> */}
          {/* <Link to='#' className={styles.button} onClick={()=>Contact()}>
            <svg xmlns="http://www.w3.org/2000/svg" width={"1.6vh"} height={"1.6vh"} viewBox="0 0 16 16" fill="none">
              <path d="M6.69181 3.54395L7.12448 4.31924C7.51495 5.01889 7.3582 5.93672 6.74322 6.5517C6.74322 6.5517 6.74322 6.5517 6.74322 6.55171C6.74311 6.55182 5.99737 7.29777 7.34976 8.65016C8.70149 10.0019 9.4474 9.25751 9.44821 9.2567C9.44824 9.25667 9.44823 9.25669 9.44825 9.25666C10.0632 8.64171 10.981 8.48497 11.6807 8.87543L12.456 9.30811C13.5125 9.89772 13.6372 11.3793 12.7086 12.308C12.1506 12.866 11.467 13.3002 10.7114 13.3288C9.43926 13.377 7.27893 13.0551 5.11188 10.888C2.94483 8.72098 2.62289 6.56065 2.67112 5.28856C2.69976 4.5329 3.13395 3.84933 3.69195 3.29132C4.62058 2.36269 6.1022 2.48746 6.69181 3.54395Z" fill="#51525C" />
            </svg>
            {t('Support')}
          </Link> */}
        </div>
      </div>
      <div></div>
    </div>
  );
}
